module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS4.04db5b4b.jpg";